@use '../../style/utils';

:host {
    /**
   * @prop --template-sidebar-width: Overrides the sidebar width. Default is 320px.
   * @prop --template-layout-width: Should not be overriden, because it's a very strict design system rule! If you don't have choice, use it to override default 1024 layout width.
   * @prop --template-layout-background-color: Default global background color. Default is neutral-1.
   * @prop --template-inner-spacing: Default global inner spacing. Default is spacing-8.
   */
    --template-sidebar-width: 320px;
    --template-layout-width: 1024px;
    --template-layout-background-color: var(--joy-color-neutral-10);
    --template-inner-spacing: var(--joy-core-spacing-8);

    display: block;
    background-color: var(--template-layout-background-color);
}

:host([full]) {
    --template-layout-width: 100%;
}

// We are going to use hn tags and they already have style most of the time. Let's override it.
::slotted([slot='template-title']) {
    @include utils.getFontProperties(primary-650, !important);
    color: var(--joy-color-neutral-60) !important;
    margin: 0 0 var(--joy-core-spacing-2) 0 !important;
}

::slotted([slot='template-subtitle']) {
    @include utils.getFontProperties(primary-400, !important);
    color: var(--joy-color-neutral-50) !important;
    margin: 0 !important;
}

::slotted([slot='template-actions']) {
    margin-left: var(--joy-core-spacing-3);

    @media screen and (max-width: 767px) {
        flex-basis: 100%;
        margin: var(--joy-core-spacing-6) 0 0 0;
    }
}

::slotted([slot='template-main']) {
    flex: 1;
    word-break: break-word;
}

::slotted([slot='template-sidebar']) {
    flex: 0 0 var(--template-sidebar-width);
    max-width: var(--template-sidebar-width);
    word-break: break-word;
}

.joy-layout {
    max-width: var(--template-layout-width);
    margin: 0 auto;
    padding: var(--template-inner-spacing);
    box-sizing: border-box;
}

.joy-layout__heading {
    display: flex;
    align-items: flex-start;
    padding: 0;
    margin-bottom: var(--joy-core-spacing-8);

    @media screen and (max-width: 767px) {
        flex-wrap: wrap;
    }

    &__headings {
        flex: 1;
    }

    ::slotted([slot='template-back']) {
        margin-right: var(--joy-core-spacing-3);
        margin-top: calc(var(--joy-core-spacing-2) * -1);
    }
}

.joy-layout__content {
    display: flex;
    align-content: flex-start;
    flex-wrap: nowrap; // we manually set the breaking point
    gap: var(--joy-core-spacing-8);

    &--reverse {
        flex-direction: row-reverse;
    }

    @media screen and (max-width: 1024px) {
        &,
        &--reverse {
            flex-wrap: wrap;
        }

        ::slotted([slot='template-sidebar']),
        ::slotted([slot='template-main']) {
            flex: 1 0 100%;
        }

        ::slotted([slot='template-sidebar']) {
            max-width: none;
        }

        ::slotted(joy-panel) {
            --panel-bottom-margin: 0;
        }
    }
}
